import { call, put, select, StrictEffect, takeLatest } from 'redux-saga/effects';
import asyncErrorHandler from 'utils/asyncErrorHandler';
import { RootState } from 'store';
import { fetchUserPerformanceReport, UserPerformanceReport } from '../services/userPerformanceReport';

import {
  getReportUserPerformance,
  setReportUserPerformanceLoading,
  setReportUserPerformanceData,
  setReportUserPerformanceError,
  setReportUserPerformanceFilter,
  setReportUserPerformanceFilterDateRange,
  resetReportUserPerformanceFilterDropdown,
  ReportUserPerformanceState,
} from './reportUserPerformance-slice';

function* getReportUserPerformanceSagaListener() {
  const filters: ReportUserPerformanceState['filters'] = yield select((store: RootState) => store.reportUserPerformance.filters);

  try {
    yield put(setReportUserPerformanceLoading());

    const report: UserPerformanceReport = yield call(fetchUserPerformanceReport, {
      dateFrom: filters.dateRange?.[0]?.format('YYYY-MM-DD'),
      dateTo: filters.dateRange?.[1]?.format('YYYY-MM-DD'),
      userTypes: filters.userTypes,
      source: filters.source,
      projectPlan: filters.projectPlan,
      categories: filters.categories,
    });

    yield put(setReportUserPerformanceData(report));
  } catch (error) {
    yield put(setReportUserPerformanceError(error));
    asyncErrorHandler(error);
  }
}

function* reportUserPerformanceSaga(): Generator<StrictEffect> {
  yield takeLatest(getReportUserPerformance.type, getReportUserPerformanceSagaListener);
  yield takeLatest(setReportUserPerformanceFilter.type, getReportUserPerformanceSagaListener);
  yield takeLatest(setReportUserPerformanceFilterDateRange.type, getReportUserPerformanceSagaListener);
  yield takeLatest(resetReportUserPerformanceFilterDropdown.type, getReportUserPerformanceSagaListener);
}

export default reportUserPerformanceSaga;
